import { Component, OnInit } from '@angular/core';

import { AuthenticationService } from '../_service/authentication.service';
import { GlobalEventsService } from '../_service/globalevents.service';

@Component({
    selector: 'navheader',
    templateUrl: 'navheader.component.html',
    styleUrls: ['navheader.component.css'],
})
export class NavheaderComponent implements OnInit {
    navbarCollapsed = true;
    isLoggedIn = false;
    showNavBar = false;

    constructor(private auth: AuthenticationService,
                private globalEventsService: GlobalEventsService) {
        this.globalEventsService.showIsLoggedInEmitter.subscribe((mode) => {
            this.isLoggedIn = mode;
        });
    }

    ngOnInit() {
        this.isLoggedIn = this.auth.isLoggedIn();
    }

    toggleMenu() {
        this.navbarCollapsed = !this.navbarCollapsed;
    }
}
